import { CircleAlert } from "lucide-react"

import {
  TableIconMessagePlaceholder,
  TableIconMessagePlaceholderProps,
} from "./TableIconMessagePlaceholder"
import { classNames } from "../../../../lib/classNames"

export type TableErrorPlaceholderProps = Omit<
  TableIconMessagePlaceholderProps,
  "icon" | "message"
>

export function TableErrorPlaceholder({
  className,
  ...otherProps
}: TableErrorPlaceholderProps) {
  return (
    <TableIconMessagePlaceholder
      icon={CircleAlert}
      iconClassName="color-danger"
      message="We ran into an error, please try refreshing the page"
      className={classNames("color-danger", className)}
      {...otherProps}
    />
  )
}
